var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLanguageMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 1C14.982 1 19 5.018 19 10C19 14.982 14.982 19 10 19",
    stroke: "#3A57E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10 19C5.018 19 1 14.982 1 10C1 5.018 5.018 1 10 1",
    stroke: "#3A57E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.1675 2.05999C5.2775 6.88499 5.2775 13.116 8.1675 17.941C9.0135 19.354 10.9865 19.354 11.8325 17.941C14.7225 13.116 14.7225 6.88499 11.8325 2.05999C10.9855 0.646994 9.0135 0.646994 8.1675 2.05999Z",
    stroke: "#3A57E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9398 8.16799C13.1148 5.27799 6.88377 5.27799 2.05877 8.16799C0.645773 9.01399 0.645773 10.987 2.05877 11.833C6.88377 14.723 13.1148 14.723 17.9398 11.833C19.3528 10.986 19.3528 9.01399 17.9398 8.16799Z",
    stroke: "#3A57E8",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLanguageMap);
export default __webpack_public_path__ + "static/media/language-map.3d1abde527b1ad9fe5310eba86887be8.svg";
export { ForwardRef as ReactComponent };